import { initJourneyTable } from './journey-table';
import { initStudentTable } from './student-table';
import { initAssignVideo } from './assign-video';
import { initAssignRecipe } from './assign-recipe';
import { initAssignDailyMessage } from './assign-daily-message';
import { initVisio } from './visio';

export function coach() {
	initJourneyTable();
	initStudentTable();
	initAssignVideo();
	initAssignRecipe();
	initAssignDailyMessage();
	initVisio();
}
